import React from 'react';

function BenifitInformation({
  ele,
  myKey,
  handleAcordion,
  accord,
  coverBenefits,
}) {
  return (
    <>
      <div
        className="right-widgit-sub-header"
        onClick={() => handleAcordion(myKey)}
      >
        {accord === myKey ? (
          <span dangerouslySetInnerHTML={{ __html: '&#9660;' }} />
        ) : (
          <span dangerouslySetInnerHTML={{ __html: '&#9658;' }} />
        )}

        {ele}
      </div>
      <div className={accord === myKey ? '' : 'hide'}>
        <div className="" style={{ height: '400px', overflowY: 'auto' }}>
          <div
            className="left width100 one-edge-shadow clear-bottom"
            style={{ fontSize: '12px' }}
          >
            <table
              className="pms-th-hdng-colr"
              width="100%"
              cellSpacing="0"
              cellPadding="0"
              border="0px"
              align="left"
            >
              <thead>
                <tr style={{ background: '#f2f9ea' }}>
                  <th
                    className="gw7"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft1: '1px solid #D8DFD',
                    }}
                  >
                    Benefit Code
                  </th>
                  <th
                    className="gw7"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                  >
                    Coverage Level
                  </th>
                  <th
                    className="gw12"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                  >
                    Service Type
                  </th>
                  <th
                    className="gw12"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                  >
                    Insurance Type
                  </th>
                  <th
                    className="gw10"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                    align="left"
                  >
                    Plan Coverage Description
                  </th>
                  <th
                    className="gw6"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                    align="left"
                  >
                    Time Period
                  </th>
                  <th
                    className="gw5"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                    align="right"
                  >
                    Benefit Amount
                  </th>
                  <th
                    className="gw6"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                    align="left"
                  >
                    Benefit Percent
                  </th>
                  <th
                    className="gw7"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                    align="left"
                  >
                    Quantity Type
                  </th>
                  <th
                    className="gw7"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                    align="left"
                  >
                    Benefit Quantity
                  </th>
                  <th
                    className="gw12"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                    align="left"
                  >
                    Authorization or Certification Indicator
                  </th>
                  <th
                    className="gw9"
                    style={{
                      padding: '8px 0px 7px 5px',
                      borderTop: '1px solid #D8DFD0',
                      borderBottom: '1px solid #D8DFD0',
                      borderLeft: '1px solid #D8DFD0',
                    }}
                    align="left"
                  >
                    In plane network indicator
                  </th>
                </tr>
              </thead>

              {coverBenefits[ele].map((benefit, index) => (
                <tbody key={index}>
                  <tr>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD',
                      }}
                    >
                      {benefit.benefit_code}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.benefits_coverage_level}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.service_code_str}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.insurance_type_code}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.plan_coverage_desc}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.time_period_qual}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.benefit_amount}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.benefit_percent}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.quantity_qual}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.benefits_quantity}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.auth_cert_number}
                    </td>
                    <td
                      style={{
                        padding: '8px 0px 7px 5px',
                        borderTop: '1px solid #D8DFD0',
                        borderBottom: '1px solid #D8DFD0',
                        borderLeft: '1px solid #D8DFD0',
                      }}
                    >
                      {benefit.network_indicator}
                    </td>
                  </tr>
                  {/*plan Date code start*/}
                  {benefit.plan_date ? (
                    <tr>
                      <td
                        style={{
                          padding: '8px 0px 7px 5px',
                          borderTop: '1px solid #D8DFD0',
                          borderBottom: '1px solid #D8DFD0',
                          borderLeft: '1px solid #D8DFD0',
                        }}
                        colSpan="12"
                        align="left"
                      >
                        <span> Plan :{benefit.plan_date}</span>
                      </td>
                    </tr>
                  ) : (
                    ''
                  )}
                  {/*plan Date code End*/}
                  {/*Details message code start*/}
                  {benefit.benefit_message ? (
                    <tr>
                      <td
                        style={{
                          padding: '8px 0px 7px 5px',
                          borderTop: '1px solid #D8DFD0',
                          borderBottom: '1px solid #D8DFD0',
                          borderLeft: '1px solid #D8DFD0',
                        }}
                        colSpan="12"
                        align="left"
                      >
                        <span> Detail :{benefit.benefit_message}</span>
                      </td>
                    </tr>
                  ) : (
                    ''
                  )}
                  {/*Details message code End*/}
                </tbody>
              ))}
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default BenifitInformation;
